import { ref, readonly } from '@vue/runtime-core';

// État global partagé
const isLoaderVisible = ref(false);

export function useHtmlGenerationLoader() {
  const showLoader = () => {
    isLoaderVisible.value = true;
  };

  const hideLoader = () => {
    isLoaderVisible.value = false;
  };

  return {
    isLoaderVisible: readonly(isLoaderVisible),
    showLoader,
    hideLoader
  };
}